import React from "react";
import HeroSection from "./HeroSection";
import Logo from "./Logo";
import Meta from "./Meta";
import Feature from "./Feature";
import UseCases from "./UseCases";
import TokenAllocation from "./TokenAllocation";
import Discount from "./Discount";
import Community from "./Community";
import RoadMap from "./RoadMap";
const Home = () => {
  return (
    <div>
      <HeroSection />
      <Logo />
      <Meta />
      <Feature />
      <UseCases />
      <TokenAllocation />
      <RoadMap />
      <Discount />
      <Community />
    </div>
  );
};

export default Home;
